export default __webpack_public_path__ + "static/professional-training-banner-image-355a658e074ad787c433bd93abb8881a.png";